import React, { useContext } from "react";
import cs from "classnames";
import classes from "./CharactersModal.module.scss";
import PropTypes from "prop-types";
import { StoreContext } from "../../../../../contexts";
import { observer } from "mobx-react-lite";
import { formatChildNames } from "../../WritingCompetition";
import StorySection from "./components/StorySection/StorySection";

const CharactersModal = observer(() => {
  const { common } = useContext(StoreContext);

  const characterData = common.get("currentCharacter");

  console.log(characterData, 'characterData');

  const childNames = formatChildNames(characterData?.selected_childs);
  const toichen = characterData?.character_submission?.data?.toichen;
  const storyBuilding = characterData?.character_submission?.data?.storyBuilding;

  return (
    <div className={cs(classes.characterFormModal)}>
      <div className={cs(classes.headerCharacter)}>
        <h2 className={cs(classes.heading, classes.grandstanderFamily)}>Writers:</h2>
        <h2 className={cs(classes.heading, classes.grandstanderFamily, classes.red)}>{childNames}</h2>
        <p className={cs(classes.red)}>
          From {characterData?.location?.address && `${characterData.location.address} `}
        </p>
      </div>

      {/* My Possuk Section */}
      {toichen?.possuk && (
        <div className={cs("mt-10 mr-auto ml-auto")}>
          <div className={cs(classes.possukBox)}>
            <span className={cs(classes.possukLabel, classes.grandstanderFamily)}>My Possuk is: </span>
            <span className={cs(classes.possukValue, classes.grandstanderFamily)}>{toichen.possuk}</span>
          </div>
        </div>
      )}

      {/* My Story Section */}
      {storyBuilding && (
        <div className={cs(classes.bodyCharacter)}>
          <h2 className={cs(classes.heading, classes.grandstanderFamily)}>My Story:</h2>
          
          <div className={cs(classes.storySectionsContainer)}>
            {/* Beginning */}
            {storyBuilding.beginning && (
              <StorySection
                label="Beginning"
                description="How does your story start?"
                content={storyBuilding.beginning}
                rows={3}
              />
            )}

            {/* Middle */}
            {storyBuilding.middle && (
              <StorySection
                label="Middle"
                description="What goes wrong or gets complicated?"
                content={storyBuilding.middle}
                rows={3}
              />
            )}

            {/* End */}
            {storyBuilding.end && (
              <StorySection
                label="End"
                description="What happens in the end? How is the problem fixed?"
                content={storyBuilding.end}
                rows={3}
              />
            )}
          </div>
        </div>
      )}

    </div>
  );
});

CharactersModal.propTypes = {
  characterData: PropTypes.object,
};

export default CharactersModal;